import {BaseModel} from "../../../../infrastructure/models/base-model";
import {DEFAULT_ODDS_TYPE, ODDS_TYPES} from "../../../../core/components/odds/components/odds-consts";
import {UserCountryConfig} from "./user-country.config";

export class UserCountryModel extends BaseModel{
  id: Number;
  hideLanguages: Array<Number> = [];
  defaultOddsType: ODDS_TYPES;

  constructor(model: UserCountryConfig, id: Number) {
    super(model);

    this.id = id;
    this.hideLanguages = model.hideLanguages;
    this.defaultOddsType = model.defaultOddsType || DEFAULT_ODDS_TYPE;
  }
}